import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";

import Tooltip from "../common/Tooltip";
import * as types from "../../constants/ComponentConstants";
import ValidationMessage from "../common/ValidationMessage";
import RadioButtonGroup from "../common/RadioButtonGroup";

const RadioButtonChild = (props) => {
	const hasValidationMessage = !!props.validationMessage;
	const validationMessageType = props.validationMessageType;
	const tooltiptype = props.tooltipType || types.TOOLTIP_INFO;
	const sizeClassName = props.size ? "o-col-" + props.size : "o-col-12";
	const label = props.label + (props.optional ? " (Optioneel)" : "");
	const value = props.value ? props.value : "";
	const info = props.tooltip ? <Tooltip text={props.tooltip} tooltipType={tooltiptype} /> : null;
	const validation = hasValidationMessage ? <ValidationMessage validationMessage={props.validationMessage} type={validationMessageType} /> : null;
	const optionList = [{ value: "true", label: 'Ja' }, { value: "false", label: 'Nee' }];
	const horizontal = !!props.horizontal;
	const tooltip = props.tooltip ? props.tooltip : "";
	const disabled = !!props.disabled;
	const locked = !!props.locked;
	const optional = !!props.optional;

	const childJa = props.childJa && (props.value === "true" || props.value == true) ?
		props.childJa : null;
	const childNee = props.childNee && (props.value === "false" || props.value == false) ?
		props.childNee : null;

	return (
		<div className={"u-clear"}>
			<RadioButtonGroup
				labelInside={props.labelInside}
				name={props.name}
				label={props.label}
				onChange={props.onChange}
				items={optionList}
				value={props.value}
				horizontal={horizontal}
				tooltip={tooltip}
				tooltipType={tooltiptype}
				disabled={disabled}
				optional={optional}
				locked={locked}
				lockedText={props.lockedText}
				validationMessage={props.validationMessage}
				validationMessageType={props.validationMessageType}
				size={props.size}
			/>
			{childJa}
			{childNee}
		</div>
	);
};

RadioButtonChild.propTypes = {
	name: PropTypes.string.isRequired,
	label: PropTypes.string,
	value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
	onChange: PropTypes.func.isRequired,
	tooltip: PropTypes.string,
	tooltipType: PropTypes.string,
	horizontal: PropTypes.bool,
	labelInside: PropTypes.bool,
	size: PropTypes.number,
	validationMessage: PropTypes.string,
	validationMessageType: PropTypes.string,
	disabled: PropTypes.bool,
	locked: PropTypes.bool,
	lockedText: PropTypes.string,
	optional: PropTypes.bool,
	childNee: PropTypes.element,
	childJa: PropTypes.element
};

export default RadioButtonChild;
